import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import swal from "sweetalert2";
import $, { error } from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from './../../../modal/Complaint_Management/Manage_Complaints/AddComplaint';
import Solution from '../../../modal/Complaint_Management/Manage_Complaints/ComplaintResolution';
import ViewComplaint from '../../../modal/Complaint_Management/Manage_Complaints/ViewComplaint';
import Resolved from '../../../modal/complaints/Resolved';
import Reopen from '../../../modal/Complaint_Management/Manage_Complaints/ComplaintReopen';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Complaints = () => {


    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ----------------------- branch --------------------
        man_branch: 0,
        branch_list: 0,
        branch_add: 0,
        branch_edit: 0,
        branch_view: 0,
        branch_delete: 0,
        branch_add_staff: 0,
        branch_add_area: 0,
        branch_add_dpoint: 0,
        branch_asign_manager: 0,
        branch_asign_cug: 0,
        
        man_dpoint: 0,
        dpoint_list: 0,
        dpoint_edit: 0,
        dpoint_delete: 0,
        dpoint_assign_vehicle: 0,

        // --------------------------- pack -------------------
        pack_man: 0,
        man_product: 0,
        prod_catego: 0,
        product_category_list: 0,
        product_category_add: 0,
        product_category_edit: 0,
        product_category_delete: 0,

        product: 0,
        products_list: 0,
        products_add: 0,
        products_edit: 0,
        products_view: 0,
        products_delete: 0,
        products_item_quantity: 0,

        item_quans: 0,
        item_quantity_list: 0,
        item_quantity_edit: 0,
        item_quantity_view: 0,

        man_pack: 0,
        package_list: 0,
        package_edit: 0,
        package_delete: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list : 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

        // ------------------------------- subscription ------------------
        subs_man: 0,
        man_subs: 0,
        subscription_list: 0,
        subscription_view: 0,
        subscription_edit: 0,
        subscription_export: 0,
        subscription_hold: 0,
        subscription_complaints: 0,
        subscription_renewal: 0,
        subscription_payment: 0,
        subscription_drop: 0,
        subscription_special_case: 0,

        man_order: 0,
        order_list: 0,
        order_edit: 0,
        order_view: 0,
        order_new_subs: 0,
        order_drop_subs: 0,
        order_convert_subscriber: 0,

        man_drop: 0,
        drop_list: 0,
        drop_export: 0,

        // ----------------------------------- payment ------------------------
        pay_man: 0,
        man_payment: 0,
        payment_export: 0,
        payment_list: 0,
        
        man_refund: 0,
        refund_list: 0,
        refund_export: 0,
        refund_update: 0,

        // -------------------------- production ----------------------
        prod_man: 0,
        man_items: 0,
        item_catego: 0,
        item_category_list: 0,
        item_category_add: 0,
        item_category_edit: 0,
        item_category_delete: 0,

        item_sub_catego: 0,
        item_sub_category_list: 0,
        item_sub_category_add: 0,
        item_sub_category_edit: 0,
        item_sub_category_delete: 0,

        items: 0,
        items_list: 0,
        items_add: 0,
        items_edit: 0,
        items_view: 0,
        items_delete: 0,
        item_needed_material: 0,
        item_receipe_notes: 0,

        comp_man: 0,
        complaint_list: 0,
        complaint_add: 0,
        complaint_status: 0,
        complaint_view: 0,

        maintenance_man: 0,
        man_vehi: 0,
        vehicle_list: 0,
        vehicle_add: 0,
        vehicle_edit: 0,
        vehicle_view: 0,
        vehicle_delete: 0,
        vehicle_maintannce: 0,
        vehicle_export: 0,

        man_mainten: 0,
        maintenance_list: 0,
        maintenance_edit: 0,
        maintenance_status: 0
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);

    const [total_complaints, settotalcomplaints] = useState(0);
    const [open_complaints, setopencomplaints] = useState(0);
    const [closed_complaints, setclosedcomplaints] = useState(0);
    const [resolved_complaints, setresolvedComplaints] = useState(0);
    const [reopen_complaints, setReopenComplaints] = useState(0);
    const [inprogressComplaints, setInProgressComplaints] = useState(0);

    // page table data fetch
    const fetchData = (filter = {}) => {
        axios.get(`${baseURL}/complaint`, {
            params: {
                ...filter,
                page,
                per_page: perPage,
                search: searchTerm,
                branch_id: branch_id
            }
        }).then(response => {
            setData(response.data.data);
            setHasFetched(true);
        }).catch(error => {
            console.log('There was an error fetching the data!', error);
            setHasFetched(true);
        });
    };

    const fetchcount = () => {
        axios.get(`${baseURL}/complaint/counts`, {
            params: {
                branch_id: branch_id
            }
        }).then(response => {
            settotalcomplaints(response.data.total_complaints);
            setopencomplaints(response.data.open_complaints);
            setclosedcomplaints(response.data.closed_complaints);
            setresolvedComplaints(response.data.resolved_complaints);
            setReopenComplaints(response.data.reopen_compalints);
            setInProgressComplaints(response.data.inprogress_complaints);
        }).catch(error => {
            console.log('There was an error fetching the data!', error);
        });
    };

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
        fetchcount();
    }, [page, searchTerm, perPage]);

    const tableRef = useRef(null);

    // soft refresh
    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
        fetchcount();
    }

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const handleModalToggle = () => {
        setModalType("Add");
        setOpen(true);
    };

    const [selectedRow, setSelectedRow] = useState({});

    const handleModalToggle_Solution = (data) => {
        setSelectedRow(data);
        setModalType("Solution");
        setOpen(true);
    };

    const handleModalToggle_view = (data) => {
        setSelectedRow(data);
        setModalType("ViewComplaint");
        setOpen(true);
    };
   
    const resolved_inprogress = (data) => {
        swal.fire({
            html: `
                   <div class="alert alert-success px-2 py-2" role="alert">
                       Are You Sure Want to Change Status
                       <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                   </div>
                     <div class="row mb-2 text-center">
                        <p class="text-center text-danger fs-6"><b>Food / Taste</b></p>
                        <label class="text-black font-w300"><b>${data.subscriber_name} - ${data.subscriber_mobile}</b></label>
                    </div>
                     <div class="text-center mt-4 mb-3">
                       <label class="fw-bold text-info fs-2">In Progress</label>
                    </div>
               `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.put(`${baseURL}/complaint/status/${data.complaint_id}`, {complaint_status: 1})
                    .then((result) => {
                        softRefresh();
                        toast.success("Complaint Updated Successfully!");
                    }).catch(error => {
                        console.log(error);
                        softRefresh();
                        toast.error("Complaint Updation Failed");
                    });
            }
        });
    };

    const closeprogress = (data) => {
        Swal.fire({
            // title: `Are You Sure Want to Change Close Status`,
            html: `
                <div class="alert alert-success px-2 py-2" role="alert">
                    Are You Sure Want to Change Close Status
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div class="row mb-2 text-center">
                    <label class="text-black font-w300"><b>${data.subscriber_name} - ${data.subscriber_mobile}</b></label>
                </div>
                </div>
                    <div class="text-center mt-4 mb-3">
                    <label class="font-w400 text-black fs-4">Reason<span class="required">*</span></label>
                </div>
            `,
            input: 'textarea',
            inputPlaceholder: 'Reason',
            inputAttributes: {
                'maxlength': 500,
                'aria-label': 'Reason',
                'rows': 2,
            },
            showCancelButton: true,
            confirmButtonText: 'Yes, Close',
            cancelButtonText: 'No, Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm: (reason) => {
                if (!reason) {
                    Swal.showValidationMessage('Reason is required');
                }
                return reason;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                console.log('Reason:', result.value);
                const postdata = {
                    complaint_status: 3,
                    close_reason: result.value
                }
                axios.put(`${baseURL}/complaint/close/${data.complaint_id}`, postdata)
                    .then((result) => {
                        softRefresh();
                        toast.success("Complaint Closed Successfully!");
                    }).catch(error => {
                        console.log(error);
                        softRefresh();
                        toast.error("Complaint Closing Failed");
                    });
            }
        });
    };

    const handleReopenComplaint = (data) => {
        setSelectedRow(data);
        setModalType("Reopen");
        setOpen(true);
    };

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    // const [value_filter, setvaluefilter] = useState('');
    const handlefilter = (value) => {
        const filter = {
            filter: value || '',
        };
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }        
        fetchData(filter);
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Complaints</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Complaints Management</li>
                    </ol>
                </div>

                {permissions.complaint_add === 1 && (
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={handleModalToggle}>
                        <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                        <span className=''>Add Complaint</span>
                    </Link>
                )}

                {open && modalType === "Add" && (
                    <Add show={open} onClose={() => setOpen(false)} refresh={softRefresh} />
                )}
                {open && modalType === "Solution" && (
                    <Solution show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={softRefresh} />
                )}
                {open && modalType === "Resolved" && (
                    <Resolved show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "ViewComplaint" && (
                    <ViewComplaint show={open} onClose={() => setOpen(false)} data={selectedRow} />
                )}
                {open && modalType === "Reopen" && (
                    <Reopen show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={softRefresh}/>
                )}
            </div>

            <div className="row mb-3">
                <div className="d-flex justify-content-between w-100">

                    <div className="d-flex">
                        <div className="me-2">
                            <div className="border rounded px-3 py-1 border-info bg-info-light text-center cursor-pointer" onClick={() => handlefilter('total_complaints')}>
                                <label className='text-black fs-6 text-nowrap cursor-pointer'>
                                    Total
                                    <span className='d-block cursor-pointer'> Complaints </span>
                                </label>
                                <div className="d-block text-center">
                                    <label className="text-danger fs-3 m-0 fw-bold cursor-pointer">
                                    <span>{total_complaints}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className='me-2'>
                            <Link to={"#"} onClick={() => handlefilter('open_complaints')}>
                                <div className='border rounded px-3 py-1 border-danger bg-danger-light text-center cursor-pointer '>
                                    <label className='text-black fs-6 text-nowrap'>
                                        Open
                                        <span className='d-block  cursor-pointer'>Complaints</span>
                                    </label>
                                    <div className='d-block text-center  cursor-pointer'>
                                        <label className="text-danger fs-3 m-0 fw-bold">
                                            <span className="text-danger  cursor-pointer">{open_complaints}</span>
                                        </label>
                                    </div>
                                </div>
                            </Link>
                        </div>

                        <div className="me-2">
                            <div className="border rounded px-3 py-1 border-success bg-success-light text-center cursor-pointer" onClick={() => handlefilter('closed_complaints')}>
                                <label className='text-black fs-6 text-nowrap cursor-pointer'>
                                    Closed
                                    <span className='d-block cursor-pointer'>Complaints</span>
                                </label>
                                <div className="d-block text-center">
                                    <label className="text-danger fs-3 m-0 fw-bold cursor-pointer">
                                    <span>{closed_complaints}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className='me-2'>
                            <Link to={"#"} onClick={() => handlefilter('resolved_complaints')}>
                                <div className='border rounded px-3 py-1 border border-dark text-center  cursor-pointer'style={{ background: '#DCDBDB' }}>
                                    <label className='text-black fs-6 text-nowrap  cursor-pointer'>
                                        Resolved
                                        <span className='d-block  cursor-pointer'>Complaints</span>
                                    </label>
                                    <div className='d-block text-center'>
                                        <label className="text-danger fs-3 m-0 fw-bold  cursor-pointer">
                                            <span className="text-danger  cursor-pointer">{resolved_complaints}</span>
                                        </label>
                                    </div>
                                </div>
                            </Link>
                        </div>

                        <div className='me-2'>
                            <Link to={"#"}  onClick={() => handlefilter('reopen_complaints')}>
                                <div className='border rounded px-3 py-1 border-warning bg-warning-light text-center cursor-pointer'>
                                    <label className='text-black fs-6 text-nowrap cursor-pointer'>
                                        Reopen
                                        <span className='d-block'>Complaints</span>
                                    </label>
                                    <div className='d-block text-center'>
                                        <label className="text-danger fs-3 m-0 fw-bold cursor-pointer">
                                            <span className="text-danger">{reopen_complaints}</span>
                                        </label>
                                    </div>
                                </div>
                            </Link>
                        </div>

                        <div className="me-2">
                            <div className="border rounded px-3 py-1 border-info bg-info-light text-center cursor-pointer" onClick={() => handlefilter('inprogress_complaints')}>
                                <label className='text-black fs-6 text-nowrap cursor-pointer'>
                                   In Progress
                                    <span className='d-block cursor-pointer'>Complaints</span>
                                </label>
                                <div className="d-block text-center">
                                    <label className="text-danger fs-3 m-0 fw-bold cursor-pointer">
                                    <span>{inprogressComplaints}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                            
                    </div>

                </div>
            </div>

            {permissions.complaint_list === 1 && (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{  fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); // Reset to first page
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{  fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>

                    <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-50px'>Date / Time</th>
                                <th className='min-w-100px'>Customers</th>
                                <th className='min-w-80px'>Package</th>
                                <th className='min-w-80px'>Complaint Type / Source</th>
                                <th className='min-w-100px'>Complaint</th>
                                <th className='min-w-50px'>Status</th>
                                <th className='min-w-80px'>Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {datas.length === 0 && hasFetched ? (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted py-2">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {datas.map((data, index) => (
                                        <tr key={data.complaint_id}>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.date}</label>
                                                <div className='d-block'>
                                                    <label className='text-primary fw-bold fs-8'>{data.time}</label>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.subscriber_name}</label>
                                                <div className='d-block'>
                                                    <label className='text-dark font-w600 fs-8'>{data.subscriber_mobile}</label>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.product_name}</label>
                                                <div className='d-block'>
                                                    <label className='text-dark font-w600 fs-8'>{data.timeline_name}</label>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-danger fw-bold fs-7'>{data.c_type_name}</label>
                                                <div className='d-block'>
                                                    <label className='text-dark font-w600 fs-8'>{data.complaint_from === 0 ? 'Web Pannel' : 'Mobile Application'}</label>
                                                </div>
                                            </td>
                                            <td>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.complaint_convo}</span></Tooltip>} >
                                                    <label className='text-black font-w400 fs-7 w-350px text-truncate'>
                                                        {data.complaint_convo}
                                                    </label>
                                                </OverlayTrigger>
                                            </td>
                                            <td>
                                                {data.complaint_status === 0 && (
                                                    <Dropdown drop="">
                                                        <Dropdown.Toggle as="a" className={`i-false py-2 ${permissions.complaint_status === 1 ? 'cursor-pointer' : ''}`}>  
                                                            <Badge bg="danger" className='py-1 px-2 fs-8'>Open</Badge>
                                                        </Dropdown.Toggle>
                                                        {permissions.complaint_status === 1 && (
                                                            <Dropdown.Menu >
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => resolved_inprogress(data)}>In Progress</Dropdown.Item>
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => handleModalToggle_Solution(data)} >Resolved</Dropdown.Item>
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => closeprogress(data)}>Closed</Dropdown.Item>   
                                                            </Dropdown.Menu>
                                                        )}
                                                    </Dropdown>
                                                )}
                                                {data.complaint_status === 1 && (
                                                    <Dropdown drop="">
                                                        <Dropdown.Toggle as="a" className={`i-false ${permissions.complaint_status === 1 ? 'cursor-pointer' : ''} py-2`} id="droptoggle2"
                                                        >  <Badge bg="info" className='py-1 px-2 fs-8'>In Progress</Badge>
                                                        </Dropdown.Toggle>
                                                        {permissions.complaint_status === 1 && (
                                                            <Dropdown.Menu >
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => handleModalToggle_Solution(data)} >Resolved</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        )}
                                                    </Dropdown>
                                                )}
                                                {data.complaint_status === 2 && (
                                                    <Dropdown drop="">
                                                        <Dropdown.Toggle as="a" className={`i-false ${permissions.complaint_status === 1 ? 'cursor-pointer' : ''} py-2`} id="droptoggle1">  
                                                            <Badge bg="dark" className='py-1 px-2 fs-8'>Resolved</Badge>
                                                        </Dropdown.Toggle>
                                                        {permissions.complaint_status === 1 && (
                                                            <Dropdown.Menu >
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => closeprogress(data)}>Closed</Dropdown.Item>
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => handleReopenComplaint(data)}>Reopen</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        )}
                                                    </Dropdown>
                                                )}
                                                {data.complaint_status === 3 && (
                                                    <Dropdown drop="">
                                                        <Dropdown.Toggle as="a" className={`i-false ${permissions.complaint_status === 1 ? 'cursor-pointer' : ''} py-2`} id="droptoggle1">  
                                                            <Badge bg="success" className='py-1 px-2 fs-8'>Closed</Badge>
                                                        </Dropdown.Toggle>
                                                        {permissions.complaint_status === 1 && (
                                                            <Dropdown.Menu >
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => handleReopenComplaint(data)}>Reopen</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        )}
                                                    </Dropdown>
                                                )}
                                                {data.complaint_status === 4 && (
                                                    <Dropdown drop="">
                                                        <Dropdown.Toggle as="a" className={`i-false ${permissions.complaint_status === 1 ? 'cursor-pointer' : ''} py-2`} id="droptoggle1"
                                                        >  <Badge bg="warning" className='py-1 px-2 fs-8'>Reopen</Badge>
                                                        </Dropdown.Toggle>
                                                        {permissions.complaint_status === 1 && (
                                                            <Dropdown.Menu >
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => resolved_inprogress(data)}>In Progress</Dropdown.Item>
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => handleModalToggle_Solution(data)} >Resolved</Dropdown.Item>
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => closeprogress(data)}>Closed</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        )}
                                                    </Dropdown>
                                                )}
                                            </td>
                                            <td>
                                                <span className="text-end">
                                                    {permissions.complaint_view === 1 && (
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_view(data)}>
                                                                <span><i className="fa fa-eye fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    )}
                                                </span>

                                                {permissions.complaint_view != 1 && (
                                                    <div className="text-center">
                                                        No Actions
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {datas.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {totalPages * perPage - (perPage - datas.length)} entries
                                </span>
                            ):(
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                                ))}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>

                    </div>
                </div>
            )}

            {permissions.complaint_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

        </>
    )


}
export default Complaints;